import request from ".";
import { middlewareInstance } from "./middlewareInstance";
import { getAuthToken } from "../services/Auth";
import { headerConfigWithAuthorize } from "../services/Header";

// TODO: Remove as it will be not used
export const requestMemberPoint = async (requestParams) => {
  try {
    const token = await getAuthToken();
    const config = headerConfigWithAuthorize(token);

    const response = await request.get(`/api/rewards/profile`, config);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const submitMissingPoint = async (requestParams) => {
  try {
    const token = await getAuthToken();
    const response = await middlewareInstance.post(
      "/api/v1/feedbacks",
      requestParams,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};
